import React, { useEffect, useState } from 'react';
// import ReactDOM from 'react-dom'; // For React 17
import { createRoot } from 'react-dom/client'; // For React 18
import { BrowserRouter as Router, useNavigate } from 'react-router-dom';
import './styles/styles.scss';
import App from './App/App';
import reportWebVitals from './reportWebVitals';
import { ThemeContextProvider } from './contexts/themeContext';
import { AuthContextProvider } from './contexts/authContext';
import './i18n';
// ✅ Token check utility
const checkTokenValidity = () => {
	const token = localStorage.getItem('HRMS-token');
	if (token) {
		try {
			const payload = JSON.parse(atob(token.split('.')[1]));
			const currentTime = Math.floor(Date.now() / 1000);
			if (payload.exp < currentTime) {
				localStorage.removeItem('HRMS-token');
				window.location.href = '/';
			}
		} catch (e) {
			localStorage.removeItem('HRMS-token');
			window.location.href = '/';
		}
	}
};

// ✅ Run once on load
checkTokenValidity();

// ✅ Check periodically every 1 minute
setInterval(checkTokenValidity, 60000);

// ✅ Also run when user returns to tab
window.addEventListener('focus', checkTokenValidity);

const children = (
	<AuthContextProvider>
		<ThemeContextProvider>
			<Router>
				<React.StrictMode>
					<App />
				</React.StrictMode>
			</Router>
		</ThemeContextProvider>
	</AuthContextProvider>
);

const container = document.getElementById('root');

// ReactDOM.render(children, container); // For React 17
createRoot(container as Element).render(children); // For React 18

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
